import { useTranslation } from 'react-i18next';

const BENEFITS = [
  { key: 's5.b1', icon: 'ri-compasses-line' },
  { key: 's5.b2', icon: 'ri-building-2-line' },
  { key: 's5.b3', icon: 'ri-community-line' },
  { key: 's5.b4', icon: 'ri-vip-diamond-line' },
  { key: 's5.b5', icon: 'ri-roadster-line' },
  { key: 's5.b6', icon: 'ri-settings-3-line' },
];

export default function B2BSection() {
  const { t } = useTranslation();

  return (
    <section id="villa" className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="reveal mx-auto max-w-3xl text-center">
          <span className="mb-5 inline-block h-px w-12 bg-primary-500"></span>
          <h2 className="font-heading text-3xl leading-tight text-foreground-950 md:text-4xl lg:text-5xl">
            {t('s5.title')}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-foreground-600 md:text-lg">
            {t('s5.subtitle')}
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {BENEFITS.map((benefit, index) => (
            <div
              key={benefit.key}
              className={`reveal flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 px-6 py-6 transition-colors hover:border-primary-300 ${
                index % 3 === 1 ? 'reveal-delay-1' : index % 3 === 2 ? 'reveal-delay-2' : ''
              }`}
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${benefit.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <span className="text-base font-medium text-foreground-900">
                {t(benefit.key)}
              </span>
            </div>
          ))}
        </div>

        <div className="reveal reveal-delay-3 mt-12 text-center">
          <a
            href="#iletisim"
            className="inline-block whitespace-nowrap rounded-md bg-primary-500 px-8 py-3.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400"
          >
            {t('s5.cta')}
          </a>
        </div>
      </div>
    </section>
  );
}